import { makeStyles } from "@material-ui/core";
import { fade } from "@material-ui/core/styles";

export const EditFormOutputStyle = makeStyles((theme) => ({
    questionTitle: {
        margin: '0.5rem 0',
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    failureIcon: {
        fill: "#f49b51"
    },
    failureButton: {
        borderColor: "#f49b51",
        '&.Mui-disabled': {
            borderColor: "#f49b51",
            color: '#f49b51'
        }
    },
    addPhotoContainer: {
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        cursor: 'pointer',
        height: 140,
        width: 140,
        '&:hover': {
            opacity: 0.8
        }
    },
    image: {
        cursor: 'pointer'
    },
    form: {
        padding: '1rem'
    },
    notesAndPhotos: {
        margin: '0.5rem 0'
    },
    question: {
        padding: '1rem',
        margin: '1rem 0'
    },
    questionPending: {
        border: `2px solid ${theme.palette.error.main}`,
        backgroundColor: fade(theme.palette.error.main, 0.08),
    },
    required: {
        color: 'red'
    },
    reportContainer: {
        position: 'relative',
        paddingBottom: '7em',
    },
    reportActions: {
        padding: '1em',
        background: 'white',
        position: 'fixed',
        width: 'fit-content',
        bottom: '2em',
        left: '50%',
        zIndex: 1,
        marginTop: '1rem',
    },
}))